/**
 * lexer.js
 * Description: accepts LOLCODE program as raw string and returns objects of valid tokens
 */

import { keywords, STR_DELIM } from "./constants";
import {
  isLiteral,
  isKeyword,
  isVarident,
  isSpace,
  trimWhitespace,
} from "./helpers";

export function tokenize(document) {
  let code = document.split("\n");
  let tokens = [];
  let flags = {
    MULTI_COMMENTS: false,
  };

  for (let lineIndex in code) {
    let line = code[lineIndex];

    for (let charIndex = 0; charIndex < line.length; charIndex++) {
      charIndex = getNextToken(lineIndex, line, tokens, charIndex, flags);
    }
  }

  return { tokens };
}

function getNextToken(lineIndex, line, tokens, charIndex, flags) {
  // Get next token
  let startIndex = trimWhitespace(charIndex, line);
  let tokenString = getNextTokenString(startIndex, line);

  // Turn on multiline comments flag if tokenString is OBTW then skip
  if (keywords.COMMENT_START.test(tokenString)) {
    flags.MULTI_COMMENTS = true;
    return;
  }
  // Turn off multiline comments flag if tokenString is TLDR then skip
  else if (keywords.COMMENT_END.test(tokenString)) {
    flags.MULTI_COMMENTS = false;
    return;
  }
  // Skip getting tokens of whole line if it starts with comment or if multiline comments flag is on
  else if (keywords.COMMENT_LINE.test(tokenString) || flags.MULTI_COMMENTS)
    return;

  // Re-check if token might be composed of multiple words
  // -- I, BOTH, BIGGR, SMALLR, SUM, DIFF, PRODUKT, QUOSHUNT, MOD, O, YA, NO, IM
  if (
    /^I$/.test(tokenString) ||
    /^BOTH$/.test(tokenString) ||
    /^BIGGR$/.test(tokenString) ||
    /^SMALLR$/.test(tokenString) ||
    /^SUM$/.test(tokenString) ||
    /^DIFF$/.test(tokenString) ||
    /^PRODUKT$/.test(tokenString) ||
    /^QUOSHUNT$/.test(tokenString) ||
    /^MOD$/.test(tokenString) ||
    /^WON$/.test(tokenString) ||
    /^EITHER$/.test(tokenString) ||
    /^ALL$/.test(tokenString) ||
    /^ANY$/.test(tokenString) ||
    /^O$/.test(tokenString) ||
    /^YA$/.test(tokenString) ||
    /^NO$/.test(tokenString) ||
    /^IM$/.test(tokenString)
  ) {
    tokenString = getLongTokenString(
      tokenString,
      startIndex + tokenString.length,
      line
    );
  }

  if (!tokenString) return;

  //Identify type of token
  // [1] If it is a keyword
  // [2] If it is a literal
  // [3] If it is an identifier
  let type = isKeyword(tokenString);
  if (!type) type = isLiteral(tokenString);
  if (!type) type = isVarident(tokenString);
  if (!type) throw new Error(`Invalid token: ${tokenString}`);

  // Push a string if successfully built
  tokens.push(createToken(tokenString, type, [], lineIndex, startIndex));
  return startIndex + tokenString.length;
}

// Builds token string if it starts with a keyword
function getLongTokenString(tokenString, index, line) {
  index = trimWhitespace(index, line);
  let nextToken = getNextTokenString(index, line);
  if (nextToken) tokenString = tokenString.concat(" ", nextToken);
  if (/^I HAS$/.test(tokenString))
    tokenString = getLongTokenString(
      tokenString,
      index + nextToken.length,
      line
    );
  return tokenString;
}

// Gets the next word string
function getNextTokenString(index, line) {
  let strFlag = false;
  let tokenString = "";

  for (let i = index; i < line.length; i++) {
    // Special case for string literals where spaces must be considered
    if (STR_DELIM.test(line[i])) strFlag = !strFlag;
    // Continue building new token string while whitespace not encountered or
    // if we are building a string
    if (!isSpace(line[i]) || strFlag) {
      tokenString = tokenString.concat(line[i]);
      continue;
    }
    break;
  }
  return tokenString;
}

function createToken(token, type, value, line, index) {
  return {
    token: token,
    type: type,
    value: value,
    line: Number(line) + 1,
    index: index,
  };
}
